var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7 1.367a4.667 4.667 0 017.967 3.3V14a4.667 4.667 0 01-9.334 0V4.667c0-1.238.492-2.425 1.367-3.3zm3.3.966a2.333 2.333 0 00-2.333 2.334V14a2.333 2.333 0 104.666 0V4.667A2.333 2.333 0 0014 2.333z",
    fill: "#B0B0B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.833 10.5c.645 0 1.167.522 1.167 1.167V14a7 7 0 1014 0v-2.333a1.167 1.167 0 112.333 0V14a9.333 9.333 0 11-18.666 0v-2.333c0-.645.522-1.167 1.166-1.167z",
    fill: "#B0B0B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 21c.644 0 1.167.522 1.167 1.167v4.666a1.167 1.167 0 11-2.334 0v-4.666c0-.645.523-1.167 1.167-1.167z",
    fill: "#B0B0B0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.167 26.833c0-.644.522-1.166 1.166-1.166h9.334a1.167 1.167 0 010 2.333H9.333a1.167 1.167 0 01-1.166-1.167z",
    fill: "#B0B0B0"
  })));
}

export default SvgMic;